/* THIS IS A GENERATED FILE, DO NOT EDIT */
export const mutationKeyFields: Record<string, { keyFields: [] }> = {
  "BulkUpdateAccountResponseOrError": {
    "keyFields": []
  },
  "AccountBulkUpdatePaymentPrefsResponseOrError": {
    "keyFields": []
  },
  "AccountOps": {
    "keyFields": []
  },
  "ActivateGlobalUserResponse": {
    "keyFields": []
  },
  "ApiFirstDiligenceOps": {
    "keyFields": []
  },
  "ArenaOps": {
    "keyFields": []
  },
  "ArenaStyleSettingsResponseOrError": {
    "keyFields": []
  },
  "AssetOps": {
    "keyFields": []
  },
  "AssetReportTemplateOps": {
    "keyFields": []
  },
  "AsyncJobOps": {
    "keyFields": []
  },
  "AuthOps": {
    "keyFields": []
  },
  "AuthorizeExtensionFieldsUpload": {
    "keyFields": []
  },
  "BulkUpdateExtensionFields": {
    "keyFields": []
  },
  "CreateLpConsolidationResponse": {
    "keyFields": []
  },
  "ClearPortalUserNewLinkedArenasResponse": {
    "keyFields": []
  },
  "ConfirmNewEmailResponse": {
    "keyFields": []
  },
  "ContactOps": {
    "keyFields": []
  },
  "CreateFolderDocumentsResponse": {
    "keyFields": []
  },
  "CreateProspectsObjectTypeOrError": {
    "keyFields": []
  },
  "MutationSuccessOrErrorResponse": {
    "keyFields": []
  },
  "DeleteUploadFileOps": {
    "keyFields": []
  },
  "DistributionOps": {
    "keyFields": []
  },
  "DocumentCategoryOps": {
    "keyFields": []
  },
  "DocumentOps": {
    "keyFields": []
  },
  "DownloadArenasTermsOfUseAndPrivacyPolicies": {
    "keyFields": []
  },
  "DownloadDataRoomDocumentsResponse": {
    "keyFields": []
  },
  "DownloadFolderContentsResponse": {
    "keyFields": []
  },
  "ESignatureOps": {
    "keyFields": []
  },
  "EditDataRoomConfigurationSettingsResponseOrError": {
    "keyFields": []
  },
  "EditorTemplateOps": {
    "keyFields": []
  },
  "EmailOps": {
    "keyFields": []
  },
  "EmailSettingsOps": {
    "keyFields": []
  },
  "EntityBulkOps": {
    "keyFields": []
  },
  "EntityCollectionOps": {
    "keyFields": []
  },
  "EntityOps": {
    "keyFields": []
  },
  "EntitySubTypeOps": {
    "keyFields": []
  },
  "ExportExtensionFields": {
    "keyFields": []
  },
  "FeatureFlagOps": {
    "keyFields": []
  },
  "FeedbackOps": {
    "keyFields": []
  },
  "FieldAccessOps": {
    "keyFields": []
  },
  "FieldPermissionOps": {
    "keyFields": []
  },
  "FinishUpOps": {
    "keyFields": []
  },
  "FundAdminServiceRequestMutationOps": {
    "keyFields": []
  },
  "GeneratePresignedUrls": {
    "keyFields": []
  },
  "GeneratePrivateEdgeTemplateOps": {
    "keyFields": []
  },
  "GenerateTotpQrCodeResponse": {
    "keyFields": []
  },
  "GetPositionsBySubscriptionAndProspectIds": {
    "keyFields": []
  },
  "GlobalUserOps": {
    "keyFields": []
  },
  "ImportExtensionFields": {
    "keyFields": []
  },
  "ImportOps": {
    "keyFields": []
  },
  "InsightsOps": {
    "keyFields": []
  },
  "InvestorDiligenceOps": {
    "keyFields": []
  },
  "InvestorDiligenceV2Ops": {
    "keyFields": []
  },
  "KbaQuestionsOps": {
    "keyFields": []
  },
  "KbaQuestionsV2Ops": {
    "keyFields": []
  },
  "KycInviteOps": {
    "keyFields": []
  },
  "LoginResponse": {
    "keyFields": []
  },
  "LogoutObject": {
    "keyFields": []
  },
  "LpProfileMutationOps": {
    "keyFields": []
  },
  "ManageObjectGroupMembershipBulkObjectTypeOrError": {
    "keyFields": []
  },
  "ManagerInviteOps": {
    "keyFields": []
  },
  "NoteOps": {
    "keyFields": []
  },
  "PerfMetricsOps": {
    "keyFields": []
  },
  "PortalAccessOps": {
    "keyFields": []
  },
  "PortalInvestmentsOps": {
    "keyFields": []
  },
  "PortalInvestorReportOps": {
    "keyFields": []
  },
  "PortalTransactionsOps": {
    "keyFields": []
  },
  "PortalTransactionsOpsDeprecated": {
    "keyFields": []
  },
  "PositionOps": {
    "keyFields": []
  },
  "PublicationOps": {
    "keyFields": []
  },
  "PublishTransactionDataOps": {
    "keyFields": []
  },
  "QuarterlyDataUploadOps": {
    "keyFields": []
  },
  "MutationErrorResponse": {
    "keyFields": []
  },
  "ReportTemplateOps": {
    "keyFields": []
  },
  "ResetPassword": {
    "keyFields": []
  },
  "ResetPasswordRequest": {
    "keyFields": []
  },
  "ResetUserTwoFa": {
    "keyFields": []
  },
  "GridViewObjectTypeOrError": {
    "keyFields": []
  },
  "SetDocusignSoboEmailAddress": {
    "keyFields": []
  },
  "SetGlobalPortalLoginCookiesResponse": {
    "keyFields": []
  },
  "SettingsAddTaskResponseOrError": {
    "keyFields": []
  },
  "SsoConfigOps": {
    "keyFields": []
  },
  "StoredEmailOps": {
    "keyFields": []
  },
  "SubscriptionDocumentOps": {
    "keyFields": []
  },
  "SubscriptionOps": {
    "keyFields": []
  },
  "SubscriptionContactOrErrorResponse": {
    "keyFields": []
  },
  "SubscriptionCounterpartyOrErrorResponse": {
    "keyFields": []
  },
  "SubscriptionV2DocumentOps": {
    "keyFields": []
  },
  "TagOps": {
    "keyFields": []
  },
  "TransactionsDeletionFields": {
    "keyFields": []
  },
  "TransactionOps": {
    "keyFields": []
  },
  "TwoFaSettingsOps": {
    "keyFields": []
  },
  "TwoStepAuthSendResponse": {
    "keyFields": []
  },
  "TwrPeriodMetricOps": {
    "keyFields": []
  },
  "UnauthenticatedUpdateTaxDocDeliveryPrefResponse": {
    "keyFields": []
  },
  "DatetimeFormatPreferencesResponse": {
    "keyFields": []
  },
  "UpdateESignatureRequestStatus": {
    "keyFields": []
  },
  "UpdateFeatureFlags": {
    "keyFields": []
  },
  "UpdateGlobalUserResponse": {
    "keyFields": []
  },
  "UpdateOpCoDetails": {
    "keyFields": []
  },
  "UpdateSubscriptionReviewDecisionResponse": {
    "keyFields": []
  },
  "UpdateUserTwoFaResponse": {
    "keyFields": []
  },
  "UploadAssistedTemplateOps": {
    "keyFields": []
  },
  "UploadEntityOps": {
    "keyFields": []
  },
  "UserFlagOps": {
    "keyFields": []
  },
  "UserOps": {
    "keyFields": []
  },
  "UserPromptsOps": {
    "keyFields": []
  },
  "VerifyPasswordResponse": {
    "keyFields": []
  },
  "VerifyTwoFaCodeResponse": {
    "keyFields": []
  },
  "ZendeskOps": {
    "keyFields": []
  }
} as const;
